import { Chip } from '@mui/material';
import { MatchVerificationStatus } from '../../types/alerts';
import { pascalCase } from '../../utils/textUtils';

const config: Record<string, { label: string; color: string; bg: string }> = {
  [MatchVerificationStatus.CORRECT]: { label: 'Correct', color: '#16a34a', bg: '#f0fdf4' },
  [MatchVerificationStatus.INCORRECT]: { label: 'Incorrect', color: '#dc2626', bg: '#fef2f2' },
};

export default function MatchVerificationChip({ status }: { status: MatchVerificationStatus | null }) {
  if (!status) return '--';
  const c = config[status];

  return (
    <Chip
      label={c?.label || pascalCase(status)}
      sx={{
        backgroundColor: c?.bg,
        color: c?.color,
        fontWeight: 500,
        borderRadius: '10px',
      }}
    />
  );
}
